(function () {
    'use strict';

    var thirdPartyCredentialsService = function ($http) {

        this.getThirdParties = function() {
            return $http.get('api/thirdpartycredentials/thirdparties/get')
                .then(function(response) {
                        return response.data;
                    },
                    function() {
                        throw ('Error getting third party credential parties');
                    });
        };

        this.getAll = function (companyId) {
            return $http.get('api/thirdpartycredentials/get_all/' + companyId)
                .then(function (response) {
                        return response.data;
                    },
                    function () {
                        throw ('Error getting third party credentials');
                    });
        };

        this.create = function (request) {
            return $http.post('api/thirdpartycredentials/create', request)
                .then(function (response) {
                        return response.data;
                    },
                    function (response) {
                        throw (response.data);
                    });
        };

        this.update = function (request) {
            return $http.post('api/thirdpartycredentials/update', request)
                .then(function (response) {
                        return response.data;
                    },
                    function (response) {
                        throw (response.data);
                    });
        };

        this.delete = function (id) {
            return $http.delete('api/thirdpartycredentials/delete/' + id)
                .then(function (response) {
                        return response.data;
                    },
                    function (response) {
                        throw (response.data);
                    });
        };
    }

    angular.module('app')
        .service('thirdPartyCredentialsService', ['$http', thirdPartyCredentialsService]);
})();